<div class="loader-overlay">
    <div class="spinner"></div>
</div>
